'use client'
import React from 'react'
import Image from 'next/image'
import DoctorsGraduation from './doctors-graduation'
import BookButton from './book-button'
import ShareButtons from './ShareButtons'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import ErrorPage from '../error-page/error-main'
import CustomLink from '../common/custom-link'


function DoctorsDetails(props) {
    const router = useRouter(); // Initialize the useRouter hook

    // Check if the data is not available, and redirect to the custom 404 page
    if (!props?.data?.data || !Array.isArray(props.data.data) || props.data.data.length === 0) {
        // router.push('/404');
        return <ErrorPage />; 
    }
    
    return (
        <div className='custom-container'>
            <div className='md:flex flex-col md:flex-row gap-3 hidden'>
                <div className='mx-auto md:mx-0'>
                {props?.data.data[0]?.attributes?.doctorProfileImage?.data?.attributes?.url ? (
                        <Image
                            src={`${process.env.NEXT_PUBLIC_BE_URL}${props.data.data[0]?.attributes.doctorProfileImage.data.attributes.url}`}
                            width={250}
                            height={300}
                            alt={props?.data.data[0]?.attributes?.doctorProfileImage?.data?.attributes?.alternativeText || 'Apex Hospitals Doctor'}
                            title={props?.data.data[0]?.attributes?.doctorProfileImage?.data?.attributes?.alternativeText || 'Apex Hospitals Doctor'}
                            className='rounded-3xl'
                        />
                        ) : (
                        <div>No image available</div>
                        )}
                </div>
                <div>
                    <div>
                        <p className='text-primaryBlue header1'>{props?.data.data[0]?.attributes.doctorName}</p>
                        <p className='header-sub text-primaryGrey mt-1 font-medium '>{props?.data.data[0]?.attributes.doctorDesignation}</p>
                    </div>
                    <DoctorsGraduation location={props?.data.data[0]?.attributes.locations.data[0].attributes.locationCity} graduation={props?.data.data[0]?.attributes.doctorGraduation}/>
                    <div className='mt-5 '>
                        <CustomLink lang={props.lang} href={`/book/book?doctor=${props?.data.data[0]?.attributes.doctorName || 'Not Defined'}&speciality=${props.data.data[0]?.attributes.specialities?.data[0]?.specialityName || 'Not Defined'}&location=${props.data.data[0]?.attributes.locations?.data[0]?.attributes.locationCity || 'Not Defined'}`}
                            className="bg-primaryBlue block w-fit text-primaryWhite rounded-full border hover:bg-buttonbg hover:border-primaryWhite hover:text-primaryWhite uppercase px-8 py-3 mt-6 mb-4 relative transition-all duration-700 p-text">
                            {props.doctorsDetials.book}
                        </CustomLink>
                    </div>
                    <ShareButtons doctorsDetials={props.doctorsDetials}/>
                </div>
            </div>
        
            <div className='md:hidden flex-col md:flex-row gap-3 block md:px-4'>
                <div>
                    <h2 className='text-primaryBlue  header1'>{props?.data.data[0]?.attributes.doctorName}</h2>
                    <p className='header-sub text-primaryGrey mt-1 font-medium'>{props?.data.data[0]?.attributes.doctorDesignation}</p>
                </div>
                <div className='mt-6'>
                {props?.data.data[0]?.attributes.doctorProfileImage?.data?.attributes?.url ? (
                        <Image
                            src={`${process.env.NEXT_PUBLIC_BE_URL}${props.data.data[0]?.attributes.doctorProfileImage.data.attributes.url}`}
                            width={250}
                            height={300}
                            alt='doctor-image'
                            className='mx-auto rounded-3xl'
                        />
                        ) : (
                        <div>No image available</div>
                        )}
                </div>
                <div className='mt-5 flex items-center justify-center'>
                    {/* <Link href={`/book/book?doctor=${props?.data.data[0]?.attributes.doctorName ? props?.data.data[0]?.attributes.doctorName : ''}&speciality=${props.data.data[0]?.attributes.specialities.data[0].specialityName ? props.data.data[0]?.attributes.specialities.data[0].specialityName : ''}&location=${props.data.data[0]?.attributes.locations.data[0].attributes.locationCity ? props.data.data[0]?.attributes.locations.data[0].attributes.locationCity : ''}`} className="bg-primaryBlue block w-fit text-primaryWhite rounded-full border hover:bg-buttonbg hover:border-primaryWhite hover:text-primaryWhite uppercase px-8 py-3 mt-6 mb-4 relative transition-all duration-700 p-text"> BOOK AN APPOINTMENT </Link> */}
                    <CustomLink lang={props.lang} href={`/book/book?doctor=${props?.data.data[0]?.attributes.doctorName || 'Not Defined'}&speciality=${props.data.data[0]?.attributes.specialities?.data[0]?.specialityName || 'Not Defined'}&location=${props.data.data[0]?.attributes.locations?.data[0]?.attributes.locationCity || 'Not Defined'}`}
                        className="bg-primaryBlue block w-fit text-primaryWhite rounded-full border hover:bg-buttonbg hover:border-primaryWhite hover:text-primaryWhite uppercase px-8 py-3 mt-6 mb-4 relative transition-all duration-700 p-text">
                        {props.doctorsDetials.book}
                    </CustomLink>
                </div>
                <ShareButtons doctorsDetials={props.doctorsDetials}/>
                <DoctorsGraduation location={props?.data.data[0]?.attributes.locations.data[0].attributes.locationCity} graduation={props?.data.data[0]?.attributes.doctorGraduation} />
            </div>
        </div>
    )
}

export default DoctorsDetails